<template>
  <div
    class="component"
    :style="[ backgroundImage ? { backgroundImage: `url(${soccerStadium})` } : {} ]"
  >
    <span class="title-text text-h5 text-sm-h4">{{ text }}</span>
    <div class="title-info">
      <div class="text-h5">
        {{ info }}
      </div>
      <div>{{ caption }}</div>
    </div>
  </div>
</template>

<script>
import soccerStadium from '@/assets/soccer-stadium.jpeg';
export default {
  name: 'Title',
  data() {
    return {
      soccerStadium,
    };
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  min-height: 100px;
  background-size: cover;
  background-position-y: bottom;
}

.title-info {
  text-align: center;
}
</style>
